import { Grid, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Box } from '@mui/material'
import { SONG_TYPES, Song, LanguageCode } from '../../../utils/types'
import SongCard from '../../../components/Card'
import { ChangeCurrentSong } from '../../../hooks/contexts/currentSongContext'
import { useContext } from 'react'
import { PolyglotContext } from '../../../polyglot/polyGlotContext'
import logo from '../../../assets/funki_VAG_1280_red.png'
import { formatKeytone, getSongTitle } from '../../../utils/songHelpes'

interface Props {
    displayedSongs: Song[]
    viewMode: 'grid' | 'list'
    changeCurrentSong: ChangeCurrentSong
    currentSong: Song | null | undefined
    type: SONG_TYPES
    lang: LanguageCode
}

const DisplayedCards = ({ displayedSongs, viewMode, changeCurrentSong, currentSong, type, lang }: Props) => {
    const currentCards = displayedSongs

    if (viewMode === 'list') {
        return <TableView currentCards={currentCards} changeCurrentSong={changeCurrentSong} currentSong={currentSong} type={type} lang={lang} />
    }

    return (
        <Grid container spacing={3}>
            {currentCards.map((song) => (
                <Grid key={song.id} item xs={12} sm={6} md={6} lg={4} xl={3}>
                    <SongCard song={song} currentSong={currentSong} changeCurrentSong={changeCurrentSong} lang={lang} />
                </Grid>
            ))}
        </Grid>
    )
}

const TableView = ({ currentCards, changeCurrentSong, currentSong, type, lang }: any) => {
    const { polyglot } = useContext(PolyglotContext)
    const isKey = type === SONG_TYPES.KEY

    return (
        <TableContainer component={Paper}>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>{isKey ? polyglot.t('library.displayedCards.tableCellKey') : polyglot.t('library.displayedCards.tableCellName')}</TableCell>
                        <TableCell>{isKey ? polyglot.t('library.displayedCards.tableCellScale') : polyglot.t('library.displayedCards.tableCellKey')}</TableCell>
                    </TableRow>
                </TableHead>

                <TableBody>
                    {currentCards.map((song: Song) => {
                        const isSelected = currentSong?.id === song.id

                        return (
                            <TableRow
                                key={song.id}
                                onClick={() =>
                                    changeCurrentSong({
                                        songId: song.id,
                                        ...(isKey && { songType: SONG_TYPES.KEY })
                                    })
                                }
                                sx={{
                                    cursor: 'pointer',
                                    background: isSelected ? (theme) => theme.palette.success.main : 'inherit'
                                }}
                            >
                                <TableCell>
                                    {isKey ? (
                                        song.key ? (
                                            song.key.tonic
                                        ) : (
                                            song.keytone
                                        )
                                    ) : (
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                            <img src={song.img ?? logo} style={{ width: 50 }} />
                                            {getSongTitle(song, lang)}
                                        </Box>
                                    )}
                                </TableCell>

                                <TableCell sx={{ width: '50%' }}>{song.key ? formatKeytone(song.key, lang, isKey) : song.keytone}</TableCell>
                            </TableRow>
                        )
                    })}
                </TableBody>
            </Table>
        </TableContainer>
    )
}

export default DisplayedCards
